import React from "react";
import "./About.css";

const skillGroups = [
  {
    label: "Full-Stack",
    items: [
      "React / Next.js",
      "Node.js / Express",
      "Python / FastAPI",
      "TypeScript",
      "PostgreSQL / MongoDB",
      "Docker",
    ],
  },
  {
    label: "AI & Automation",
    items: [
      "AI Assistants & Chatbots",
      "RAG / Document Q&A",
      "Vector Search / Embeddings",
      "LLM & API Integration",
      "LangChain",
      "Workflow Automation / n8n",
    ],
  },
];

const About = () => {
  return (
    <div className="about-page">
      <div className="about-header">
        <h1 className="about-title">
          Full-stack products, <br />
          <span className="about-title-accent">with AI built in.</span>
        </h1>
      </div>

      <div className="about-grid">
        <div className="about-text-col">
          <p>
            I'm a Full-Stack AI Engineer. I build production web applications
            end to end, and the AI that runs inside them. My core stack is
            TypeScript with React/Next.js on the front end, Node/Express and
            Python/FastAPI on the back, PostgreSQL or MongoDB underneath, and
            Docker to ship it.
          </p>
          <p>
            The AI half is where most of my recent work sits: assistants and
            chatbots that answer from a company's own documents and cite where
            each answer came from, retrieval pipelines over files that were
            never searchable before, and automated workflows that take manual
            steps out of a process. Mostly LLM APIs, LangChain and n8n:
            practical integrations rather than research.
          </p>
          <p>
            I'd rather ship something that works and is honest about its limits
            than something impressive that quietly gets things wrong. That
            applies to both halves of the stack.
          </p>
        </div>

        <div className="about-skills-col">
          <div className="skills-card">
            <div className="skills-card-title">Core Skills</div>
            {skillGroups.map((group) => (
              <div className="skills-group" key={group.label}>
                <span className="skills-group-label">{group.label}</span>
                <div className="core-skills-grid">
                  {group.items.map((skill) => (
                    <div key={skill} className="core-skill-card">
                      <div className="core-skill-dot"></div>
                      <span className="core-skill-name">{skill}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
